/**
 * Coups de pouce — Attendu 642 « Calculer des périmètres de figures
 * composées ».
 *
 * Une entrée par `generator_key` (cf. gen_642.js). Les 4 formats partagent le
 * même pool de figures : une seule fiche, référencée par les 4 clés — la
 * méthode (découper, fraction de cercle, additionner) couvre aussi le
 * demi-cercle seul sans le nommer (décision revue : pas d'info en trop).
 * Exemple HORS pools : D = 40 (les diamètres réels vont jusqu'à 30).
 * Convention du gen : touche π (revue 2026-07-31).
 */

const FICHE_COMPOSE = {
    pages: [
        {
            titre: 'Décompose la figure',
            lignes: [
                'Découpe le contour en morceaux : des **côtés droits** et des **morceaux de cercle**.',
                'Un morceau de cercle = le tour **entier** (π × D), puis **÷ 2** pour un demi-cercle, **÷ 4** pour un quart.',
                'Additionne tous les morceaux. Attention : ne compte que ce qui est **vraiment sur le contour**.',
            ],
        },
        {
            titre: 'Un exemple',
            lignes: [
                'Demi-cercle de diamètre **40** cm posé sur un côté : tour entier = π × 40 ≈ 125,66 cm.',
                'Le demi-cercle : 125,66 ÷ 2 ≈ **62,83** cm. On l\'ajoute aux côtés droits.',
            ],
        },
    ],
};

const CP_642 = {
    perimetre_compose_qcm_unique: FICHE_COMPOSE,
    perimetre_compose_texte: FICHE_COMPOSE,
    perimetre_compose_texte_trou_drag: FICHE_COMPOSE,
    perimetre_compose_texte_trou_saisie: FICHE_COMPOSE,
};

export default CP_642;
